import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const DeviceMismatchPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          mb: 4,
          p: 3,
          borderRadius: '50%',
          backgroundColor: '#e0f7fa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 120,
          height: 120,
        }}
      >
        <LockIcon sx={{ fontSize: 64, color: '#039be5' }} />
      </Box>

      <Typography variant="h5" fontWeight="bold" gutterBottom>
        This isn’t the device you tried to sign in with
      </Typography>

      <Typography variant="body1" color="textSecondary">
        Please open your email using the device you used to sign in with.
      </Typography>
    </Container>
  );
};

export default DeviceMismatchPage;
